import { render, staticRenderFns } from "./RetailerNav.vue?vue&type=template&id=fbf80744&"
import script from "./RetailerNav.vue?vue&type=script&lang=js&"
export * from "./RetailerNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports